// Test IDs for the CCTV Monitoring module.
export const CCTV = {
    page: "cctv-page",
    newBtn: "cctv-new-finding-btn",
    filterBranch: "cctv-filter-branch",
    filterCategory: "cctv-filter-category",
    filterStatus: "cctv-filter-status",
    filterDate: "cctv-filter-date",
    table: "cctv-findings-table",
    row: (id) => `cctv-row-${id}`,
    empty: "cctv-empty",

    // hub (CCTV Monitoring findings + Branch Check-in sub-tabs)
    hub: "cctv-hub",
    hubTab: (k) => `cctv-hub-tab-${k}`,

    // form / detail dialog
    dialog: "cctv-dialog",
    fBranch: "cctv-f-branch",
    fDate: "cctv-f-date",
    fTime: "cctv-f-time",
    fCategory: "cctv-f-category",
    fCategoryOther: "cctv-f-category-other",
    fSeverity: "cctv-f-severity",
    fDescription: "cctv-f-description",
    fEmployee: "cctv-f-employee",
    saveDraft: "cctv-save-draft",
    submit: "cctv-submit-btn",
    severityBadge: (id) => `cctv-severity-${id}`,
    filterSeverity: "cctv-filter-severity",
    approveSeverity: "cctv-approve-severity",

    // evidence
    evidence: "cctv-evidence",
    evidenceInput: "cctv-evidence-input",
    evidenceItem: (id) => `cctv-evidence-${id}`,
    evidenceDelete: (id) => `cctv-evidence-delete-${id}`,
    uploadProgress: "cctv-upload-progress",
    uploadError: "cctv-upload-error",
    hrClipWarning: "cctv-hr-clip-warning",
    evidenceHrFlag: (id) => `cctv-evidence-hr-flag-${id}`,

    // actions
    dispatch: "cctv-dispatch-btn",
    approve: "cctv-approve-btn",
    reject: "cctv-reject-btn",
    rejectReason: "cctv-reject-reason",
    rejectConfirm: "cctv-reject-confirm",
    editBtn: "cctv-edit-btn",
    deleteBtn: "cctv-delete-btn",
    deleteConfirm: "cctv-delete-confirm",
    deleteCancel: "cctv-delete-cancel",

    history: "cctv-history",
    historyBranchChange: (id) => `cctv-history-branch-change-${id}`,   // «نقل إلى فرع آخر» old → new
    lastReason: "cctv-last-reason",
    hrPush: "cctv-hr-push",
};
